/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair metadata request
 */
export interface UpdatePairMetadataRequest {
  pairId: number;
  metadata: string;
}
